class PivotIncrementalGradient extends HTMLElement {
  constructor() {
    super()
    this.numbers = this.querySelectorAll('.pivot-incremental-gradient-number')
    this.formatter = new Intl.NumberFormat('es-CL').format

    const intersector = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          intersector.disconnect()
          this.show()
        })
      },
      {
        rootMargin: '0px 0px -40% 0px',
        // threshold: [0.5],
      }
    )

    intersector.observe(this)
  }
  show() {
    const divider = 20
    const timmer = () =>
      setTimeout(() => {
        this.numbers.forEach(numberItem => {
          const finalValue = Number(numberItem.dataset.number)
          const currentValue = Number(numberItem.dataset.currentValue)
          if (currentValue >= finalValue) {
            numberItem.dataset.ended = true
            return
          }
          const summ = finalValue / divider
          let val = currentValue + summ

          console.log(val, this.formatter(val))
          numberItem.textContent = `${this.formatter(
            parseInt(val > finalValue ? finalValue : val)
          )}${numberItem.dataset.suffix}`
          numberItem.dataset.currentValue = val
        })
        this.numbers = this.querySelectorAll(
          '.pivot-incremental-gradient-number:not([data-ended])'
        )
        if (this.numbers.length) timmer()
      }, 1000 / 30)
    timmer()
  }
}

if (!customElements.get('pivot-incremental-gradient')) {
  customElements.define('pivot-incremental-gradient', PivotIncrementalGradient)
}

